/* src/app/components/licenses-components/licenses-licenses-list-card/licenses-licenses-list-card.component.scss */
.list-card header > div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
.list-card header .list-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}
.list-card header .table-filter {
  min-width: 18rem;
  max-width: 26rem;
  width: 100%;
  height: 3.6rem;
  border: 1px solid rgba(80, 94, 111, 0.25);
  border-radius: 0.6rem;
  padding: 0 1rem;
  font-size: 1.4rem;
  color: rgb(80, 94, 111);
  background: #fff;
}
.list-card header .table-filter:focus {
  outline: none;
  border-color: rgba(46, 125, 229, 0.7);
  box-shadow: 0 0 0 0.2rem rgba(46, 125, 229, 0.15);
}
.list-card header .finished-filter {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.4rem;
  -webkit-user-select: none;
  user-select: none;
}
.list-card header .finished-filter > input[type=checkbox] {
  width: 1.4rem;
  height: 1.4rem;
}
.list-card header .empty-state {
  margin: 1rem 0 0.5rem 0.5rem;
  opacity: 0.75;
}
.list-card header th.sortable {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  white-space: nowrap;
}
.list-card header th.sortable > span {
  font-size: 1.1rem;
  opacity: 0.75;
  margin-left: 0.35rem;
}
:host ::ng-deep tr.expiring {
  background-color: #fff4bf;
}
@media (max-width: 768px) {
  .list-card header > div {
    align-items: stretch;
  }
  .list-card header .list-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .list-card header .table-filter {
    max-width: 100%;
  }
  .list-card header .list-actions > app-mb-button {
    width: 100%;
  }
}
/*# sourceMappingURL=licenses-licenses-list-card.component.css.map */
